import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ProjectModel } from '@project/model/project.model';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { UndoBusbarArticleOperation } from './undo-busbar-article-operation';
import { IOperation } from './i-operation';
import { ProjectArticleService } from '@project/service/project-article.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { WireBridgeService } from '@project/components/article/manager/wire-bridge.service';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { ArticleLineHolder } from '@article/helper/article-line-holder';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

export class UndoDetachBusbarArticlesOperation extends UndoBusbarArticleOperation implements IOperation {

  constructor(busbarContainer: ArticleContainer,
              projectModel: ProjectModel,
              projectArticleService: ProjectArticleService,
              projectMetaElementService: ProjectMetaElementService,
              selectionModel: SelectionModel,
              selectionModelService: SelectionModelService,
              wireBridgeService: WireBridgeService,
              articleContainerLoader: ArticleContainerLoader,
              articleContainerFactory: ArticleContainerFactory,
              containerService: ContainerService,
              applicationRefreshService: ApplicationRefreshService,
              detachArticleUsageService: DetachArticleUsageService,
              articleLineHolder: ArticleLineHolder,
              connectionInfoService: ConnectionInfoService) {
    super(
      busbarContainer,
      projectModel,
      projectArticleService,
      projectMetaElementService,
      selectionModel,
      selectionModelService,
      wireBridgeService,
      articleContainerLoader,
      articleContainerFactory,
      containerService,
      applicationRefreshService,
      detachArticleUsageService,
      articleLineHolder,
      connectionInfoService);
  }

  public getQualifiedClassName(): string {
    return 'UndoDetachBusbarArticlesOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public performUndo(): Promise<void> {
    return this.attachArticles();
  }

  public performRedo(): Promise<void> {
    return this.detachArticles();
  }
}
